// Auto-generated icon module
const svg = `<svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
  <path d="M15.6,13.2l0.7,0.7L12,18.2l-4.3-4.3l0.7-0.7l3.1,3.1V7h1v9.2L15.6,13.2z M22,12c0,5.5-4.5,10-10,10S2,17.5,2,12
		S6.5,2,12,2S22,6.5,22,12z M21,12c0-5-4-9-9-9s-9,4-9,9s4,9,9,9S21,17,21,12z" />
</svg>
`;

export { svg as default };
//# sourceMappingURL=it-arrow-down-circle-I6jWec3x.js.map
